export const CURRENCY = "AED";

export function formatPrice(amount, { decimals = 2 } = {}) {
  const n = Number(amount || 0);
  return `${CURRENCY} ${n.toLocaleString("en-AE", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
}
